import React from "react";
import Right from "@material-ui/icons/NavigateNext";
import Left from "@material-ui/icons/NavigateBefore";
import YouTube from "react-youtube";

import ale from "../assets/img/exemplars/ale.png";
import bur from "../assets/img/exemplars/bur.png";
import dar from "../assets/img/exemplars/dar.png";
import eva from "../assets/img/exemplars/eva.png";
import gri from "../assets/img/exemplars/gri.png";
import jac from "../assets/img/exemplars/jac.png";
import kal from "../assets/img/exemplars/kal.png";
import mar from "../assets/img/exemplars/mar.png";
import ori from "../assets/img/exemplars/ori.png";
import sol from "../assets/img/exemplars/sol.png";
import val from "../assets/img/exemplars/val.png";
import zul from "../assets/img/exemplars/zul.png";

import aleChar from "../assets/img/exemplars/aleister.PNG";
import burChar from "../assets/img/exemplars/burgundy.PNG";
import darChar from "../assets/img/exemplars/dardanelles.PNG";
import evaChar from "../assets/img/exemplars/evania.PNG";
import griChar from "../assets/img/exemplars/grimwald.PNG";
import jacChar from "../assets/img/exemplars/jacquine.PNG";
import kalChar from "../assets/img/exemplars/kali.PNG";
import marChar from "../assets/img/exemplars/marius.PNG";
import oriChar from "../assets/img/exemplars/orion.PNG";
import solChar from "../assets/img/exemplars/solomon.PNG";
import valChar from "../assets/img/exemplars/valeria.PNG";
import zulChar from "../assets/img/exemplars/zulfiqar.PNG";
import track from "./Track";

export const ExemplarsSmall = () => {
  const [charDivs, setCharDivs] = React.useState([]);
  const [selected, setSelected] = React.useState(0);
  const [circles, setCircles] = React.useState([]);
  const [anim, setAnim] = React.useState("slideIn2");
  const [selectedSNS, setSelectedSNS] = React.useState(0);
  const [playing, setPlaying] = React.useState(false);

  const SNS = ["tFeoCunTNZg", "ZY-HyCJjUpg", "XkTjBWju2XI", "n4mDLDzt5zA"];

  const chars = [
    {
      name: "Aleister",
      card: ale,
      element: "Fire",
      weapon: "Sabre",
      desc:
        "A master fencer and romantic adventurer who boldly travels the world. Aleister’s dashing looks and natural charm are known to make women swoon over him. He wanders from heart to heart in search of love.",
      sns: 0,
      img: aleChar,
    },
    {
      name: "Burgundy",
      card: bur,
      element: "Fire",
      weapon: "Injector",
      desc:
        "A smug alchemist who claims to be a princess from a forgotten empire. Burgundy boasts that she slayed a vicious dragon that would have swallowed the world whole one hundred years ago. Armed with a mysterious weapon of her own making, Burgundy can enhance her team’s elemental abilities. ",
      sns: 1,
      img: burChar,
    },
    {
      name: "Dardanelles",
      card: dar,
      element: "Fire",
      weapon: "Cannon",
      desc:
        "A beloved princess who favors festivities over fighting. While the militant kingdoms around her took great joy in conquering each other, Dardanelles sought diplomacy. Her cordial nature and starry-eyed way of speaking allowed her to befriend her neighboring countries instead of struggling with them.",
      sns: 2,
      img: darChar,
    },
    {
      name: "Evania",
      card: eva,
      element: "Water",
      weapon: "Scythe",
      desc:
        "A nun who runs an orphanage for children who lost their parents during wars. Motherly and caring to children, Evania’s soft smile turns to a devilish grin when those under her care are in jeopardy.",
      sns: 3,
      img: evaChar,
    },
    {
      name: "Grimwald",
      card: gri,
      element: "Lightning",
      weapon: "Throwing hammers",
      desc:
        "A gentle giant scarred from seeing the brutality of war. Grimwald’s booming voice radiates kindness even when speaking with his foes. Instead of being dragged down by his traumatic past, Grimwald believes it is his duty to protect life – man and animal alike.",
      sns: 2,
      img: griChar,
    },
    {
      name: "Jacquine",
      card: jac,
      element: "Water",
      weapon: "Shotgun",
      desc:
        "The daring captain of the indestructible Galleon, a ship forged from the treasure Jacquine plundered. Jacquine’s name inspires fear across the seas, but also respect from her crew that view her as an admirable leader. ",
      sns: 1,
      img: jacChar,
    },
    {
      name: "Kali",
      card: kal,
      element: "Lightning",
      weapon: "Karambits",
      desc:
        "A free-spirited shaman who feels more comfortable with felines than people. Kali identifies with wild cats because, like them, she loves nature, is not bound by a home, and is playful when she preys on her foes.",
      sns: 0,
      img: kalChar,
    },
    {
      name: "Marius",
      card: mar,
      element: "Fire",
      weapon: "Great Sword",
      desc:
        "A general determined to right the injustices of the world. Marius rushes into action when he sees tyranny and channels his rage into fiery attacks. Oppressive kings view Marius as a cruel demon of the battlefield, but the meek view him as an avenger.",
      sns: 3,
      img: marChar,
    },
    {
      name: "Orion",
      card: ori,
      element: "Water",
      weapon: "Ballista",
      desc:
        "A loner who follows the stars and believes people are better off without him. While Orion aspires to be a hero, his natural clumsiness tends to make situations worse. Orion’s sole “companion” is a rickety, mechanical turret he created that he believes is his dog. ",
      sns: 2,
      img: oriChar,
    },
    {
      name: "Solomon",
      card: sol,
      element: "Water",
      weapon: "Spear",
      desc:
        "A young, brash king who has combat prowess to back up his claims. His parents named him after King Solomon, hoping he would follow in the footsteps of the revered ruler, but all of the wisdom Solomon gained came from the battlefield.",
      sns: 0,
      img: solChar,
    },
    {
      name: "Valeria",
      card: val,
      element: "Lightning",
      weapon: "Mechanical Bow",
      desc:
        "A genius inventor driven by mechanical perfection over fame. Valeria’s erudite knowledge allows her to improve on weapons she finds giving her one-of-a-kind tools. Valeria takes great pride in her clockwork contraptions and is known to get frustrated if her inventions don’t work as planned.",
      sns: 1,
      img: valChar,
    },
    {
      name: "Zulfiqar",
      card: zul,
      element: "Lightning",
      weapon: "Sword & Shield",
      desc:
        "An oathbound knight who loyally obeys his king or queen’s orders. As captain of the Silver Brigade, Zulfiqar believes it is his duty to shield his allies and protect them even at the cost of his own life. ",
      sns: 3,
      img: zulChar,
    },
  ];

  const changePic = (type) => {
    if (type === "next") {
      setAnim("slideIn2");
      if (selected === chars.length - 1) {
        setSelected(0);
      } else {
        setSelected(selected + 1);
      }
    } else {
      setAnim("slideIn");
      if (selected === 0) {
        setSelected(chars.length - 1);
      } else {
        setSelected(selected - 1);
      }
    }
  };

  const makeChars = (chrs) => {
    setCharDivs(
      chrs.map((e, i) => {
        return (
          <div
            className={`char flex row`}
            key={i}
            style={{ animation: anim + " 0.6s ease-out forwards" }}
          >
            <img
              src={e.card}
              alt=""
              className={`char-img shadowed hide-on-small`}
            />

            <div
              className="flex start char-info-box"
              style={{
                padding: "16px",
                height: "630px",
              }}
            >
              <h2
                style={{
                  margin: "8px",
                  backgroundColor: "transparent",
                  backdropFilter: "none",
                }}
              >
                {e.name.toUpperCase()}
              </h2>
              <div className="flex row">
                <img
                  className={playing ? "flex" : "hide-on-big"}
                  src={e.card}
                  alt=""
                  height="110px"
                  style={{
                    border: "solid 1px #7600bb",
                    width: "120px",
                    height: "initial",
                    borderWidth: 0,
                    margin: "0 8px",
                  }}
                />
                {/* <div
                  className="video flex"
                  style={{
                    // , height:`${videoWidth * .5625}vw`
                    // position: "absolute",
                    // right: 32,
                    // top: "50%",

                    zIndex: 20,
                  }}
                >

                  <YouTube
                    onPlay={() => setPlaying(true)}
                    key={SNS[selectedSNS]}
                    videoId={SNS[e.sns]}
                    onPlay={() => track("SNS")}
                    opts={{
                      width: "150px",
                      height: "150px",
                    }}
                  />
                </div> */}
              </div>

              <p style={{ color: "white", marginTop: "8px" }}>{e.desc}</p>
            </div>
          </div>
        );
      })
    );
  };

  React.useEffect(() => {
    console.log("Rerendered chars");
    setSelectedSNS(chars[selected].sns);
    console.log("SNS 1-3: ", chars[selected].sns);
    makeChars(chars);
  }, [selected]);

  return (
    <div className="flex start chars hide-on-big">
      <div className="flex">
        <div className="flex row">
          <div
            className="btn viewer"
            style={{ margin: "16px", fontSize: "1rem" }}
            onClick={(e) => {
              changePic("prev");
            }}
          >
            <Left style={{ color: "white", fontSize: "2rem" }} />
          </div>
          <h2 className="chars-title" style={{ color: "white" }}>
            Exemplars
          </h2>

          <div
            className="btn viewer"
            style={{ margin: "16px", fontSize: "1rem" }}
            onClick={(e) => {
              changePic("next");
            }}
          >
            <Right style={{ color: "white", fontSize: "2rem" }} />
          </div>
        </div>
        <div className="flex row circles" style={{ padding: "8px" }}>
          <div
            onClick={() => {
              if (selected >= 0) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(0);
            }}
            className="circle"
            style={{ backgroundColor: selected === 0 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 1) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(1);
            }}
            className="circle"
            style={{ backgroundColor: selected === 1 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 2) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(2);
            }}
            className="circle"
            style={{ backgroundColor: selected === 2 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 3) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(3);
            }}
            className="circle"
            style={{ backgroundColor: selected === 3 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 4) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(4);
            }}
            className="circle"
            style={{ backgroundColor: selected === 4 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 5) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(5);
            }}
            className="circle"
            style={{ backgroundColor: selected === 5 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 6) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(6);
            }}
            className="circle"
            style={{ backgroundColor: selected === 6 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 7) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(7);
            }}
            className="circle"
            style={{ backgroundColor: selected === 7 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 8) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(8);
            }}
            className="circle"
            style={{ backgroundColor: selected === 8 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 9) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(9);
            }}
            className="circle"
            style={{ backgroundColor: selected === 9 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 10) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(10);
            }}
            className="circle"
            style={{ backgroundColor: selected === 10 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 11) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(11);
            }}
            className="circle"
            style={{ backgroundColor: selected === 11 ? "violet" : "black" }}
          ></div>
        </div>
      </div>

      <div className="flex">{charDivs[selected]}</div>
      {/* <div className="player-wrapper flex">
        <ReactPlayer
          controls={true}
          className="react-player"
          url={SNS[selectedSNS]}
          width="100%"
          height="100%"
        />
      </div> */}
    </div>
  );
};
